import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { RedirectTag, useHelmet } from '@thd-nucleus/thd-helmet';
import { number, params, shape, string, arrayOf, useDataModel } from '@thd-nucleus/data-sources';
import { RedirectContext } from './RedirectContext';
import { isReviewsCanonical } from './rules/review-redirect-rules';
import { getPathWithMergedParams, handleErrors } from '../utils/redirector-utils';
import { isNotFound } from './rules/pip-redirect-rules';

const reviewsHandler = ({ data, error, props }) => {

  const [path, queryParams] = props.pathWithQueryParams?.split('?') || '';
  const errors = handleErrors(error);
  if (errors) {
    return new RedirectTag(errors, props.bypass);
  }
  const notFound = isNotFound({ data });
  if (notFound) {
    return new RedirectTag(notFound, props.bypass);
  }

  const checkReviewsCanonical = isReviewsCanonical({ data, path });
  if (checkReviewsCanonical) {
    return new RedirectTag(checkReviewsCanonical, props.bypass);
  }
  return null;
};

export const ReviewsRedirector = () => {

  const { pathWithQueryParams, itemId, bypass } = useContext(RedirectContext);

  const opts = {
    variables: {
      itemId
    }
  };

  const props = {
    bypass,
    pathWithQueryParams
  };

  const { data, error } = useDataModel('product', opts);
  useHelmet('reviewsRedirector', { props, data, error }, reviewsHandler, [itemId]);

  return null;
};

ReviewsRedirector.propTypes = {
  ssr: PropTypes.bool,
  disablePEPRedirect: PropTypes.bool
};

ReviewsRedirector.defaultProps = {
  disablePEPRedirect: false
};

ReviewsRedirector.dataModel = {
  product: params({ itemId: string().isRequired() }).shape({
    itemId: string(),
    dataSources: string(),
    identifiers: shape({
      canonicalUrl: string()
    })
  })
};
